export const affiliateInfo = {
  date: "DATE",
  name: "Name",
  topupAmount: "TOPUP AMOUNT",
  withdrawAmount: "WITHDRAW AMOUNT",
  turnOver: "TURNOVER",
  winLoss: "WIN/LOSS",
  showing: "Showing",
  to: "to",
  results: "results",
  uplineUser: "UPLINE USER",
  username: "Username",
  mobile: "Mobile",
};
